import { render } from "./BtnFav.vue?vue&type=template&id=67882c75&scoped=true"
import script from "./BtnFav.vue?vue&type=script&lang=js"
export * from "./BtnFav.vue?vue&type=script&lang=js"

import "./BtnFav.vue?vue&type=style&index=0&id=67882c75&lang=scss&scoped=true"

import exportComponent from "/opt/app-root/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67882c75"]])

export default __exports__